import {
  AccountManager,
  actions,
  Bus,
  isEmptyCollection,
  mergeUpdate,
  SettingsManager,
} from '@atlas/core';

import history from 'components/Layout/history';
import { isEqual } from 'common/utils';

const UI_BROADCAST_EVENTS = [
  'ui:goto',
  'ui:language_change',
  'ui:betslip_open',
  'ui:currency_change',
  'ui:theme_change',
  'ui:footer_iframe',
  'ui:logout',
];

window.addEventListener('message', event => {
  // Should check the domain first
  // event.origin

  if (isEmptyCollection(event.data)) {
    return;
  }

  const { action, payload } = event.data;

  if (UI_BROADCAST_EVENTS.includes(action)) {
    Bus.emit(action, payload);
  }
});

Bus.on('ui:logout', () => {
  Bus.send({
    event: Bus.events.auth.logout,
    data: {
      withoutRedirect: true,
    },
  });
});

Bus.on('ui:goto', options => {
  history.push(options);
});

Bus.on('ui:language_change', lang => {
  SettingsManager.updateSettings({ lang });
});

Bus.on('ui:currency_change', currency => {
  AccountManager.manuallySetCurrency = currency;

  Bus.invoke({
    type: actions.ACCOUNT_UPDATE,
    payload: {
      currency,
    },
  });
});

Bus.on('ui:theme_change', theme => {
  SettingsManager.updateSettings({ theme });
});

let cachedViewportHeights = {};
const cachedPreviousValues = {
  viewport: null,
  contentHeight: null,
};

Bus.on('ui:viewport:changes', data => {
  const headerElements = window.document.querySelectorAll('.viewport-header');
  const headersHeight = Object.values(headerElements).reduce(
    (acc, element) => acc + element.offsetHeight,
    0,
  );

  cachedViewportHeights = mergeUpdate(cachedViewportHeights, data);

  const maxViewportHeight = Math.max(
    ...Object.values(cachedViewportHeights).map(viewport => viewport.height),
  );

  if (!isEqual(data, cachedPreviousValues.viewport)) {
    cachedPreviousValues.viewport = data;
    Bus.emit('ui:viewport', data);
  }

  const newContentHeight = maxViewportHeight + headersHeight;
  if (newContentHeight !== cachedPreviousValues.contentHeight) {
    cachedPreviousValues.contentHeight = newContentHeight;
    Bus.emit('ui:content_height', newContentHeight);
  }
});

Bus.on('ui:footer_iframe', footerIframe => {
  SettingsManager.updateSettings({
    footerHeight: footerIframe.footerHeight,
    footerUrl: footerIframe.footerUrl,
  });
});

Bus.on('betslip:main:bet:snapshot', data => {
  Bus.emit(Bus.events.bet.snapshot, {
    origin: 'betslip',
    ...data,
  });
});

Bus.emit('ui:device', 'desktop');
